import React, { useState } from 'react';
import { classIf, getBetDescription, getConfiguration } from '../data/utils';
import { PrematchCompetitionContext } from '../prematch/prematch-home/PrematchHomeCompetitionMacrogruppo';
import { FavoriteMarketsContext } from '../live/live-suite/LiveSuiteCompetition';
import {ReactComponent as PinIcon} from '../icons/pin.svg';
import { ReactComponent as FavoriteWh } from '../icons/favoriteWh.svg';
import MatchOdd from './MatchOdd';
import { HANDICAP_TYPES_TO_FORCE_ONE_COLUMN } from '../data/constants';
import CashoutLabel from './CashoutLabel';

function MatchBet(props) {
    const prematchCompetitionContext = React.useContext(PrematchCompetitionContext)
    const favoriteMarketsContext = React.useContext(FavoriteMarketsContext);
    const favoritesContext = prematchCompetitionContext || favoriteMarketsContext;
    const [collapsed, setCollapsed] = useState(!props.expanded);
    const sportRef = props.sportRef || (favoritesContext && favoritesContext.match.sportRef);
    const betId = `${props.id}_${props.handicap}`;
    const conf = getConfiguration();


    function toggleCollapsed() {
        setCollapsed(!collapsed);
    }

    function toggleFavorite(e) {
        e.stopPropagation();
        favoritesContext.toggleFavorite(sportRef, betId);
    }

    const oddsList = props.odds.filter(odd => odd.value != null).map(function(odd) {
        const id = `${props.uniqueId}_${odd.betId}_${odd.id}_${odd.betData.handicap}`;
        return (
            <MatchOdd key={id} betBuilder={props.betBuilder} {...odd} />
        );
    });

    let betDesc = props.desc;
    if (!props.compactView) {
        if (props.tipoHandicap === 7) {
            betDesc = props.desc + " " + props.handicapDesc; 
        } else {
            if(!props.betDescAlreadyCalc){
            	// it is true just from multilive page
	            betDesc = conf.iwh ? getBetDescription(props, false, sportRef) : getBetDescription(props, false, sportRef).toUpperCase();
            }
        }
    }

    return (
        <div className="widget-elemento-live">
            <div className="quote-extra bordo-tondo">
                <div className="quote-extra-partita">
                    <div className={"titolo-giocate-extra toggle-nascondi-live d-flex justify-content-between pointer allinea-sx padding-orizzontale padding-verticale bordo-tondo" + classIf(collapsed, 'collapsed')} href={"#barra-extra-" + props.uniqueId } role="button" onClick={toggleCollapsed}>
                        <div className="w-100 d-flex items-center justify-content-between mr-1">
                            {betDesc}
                            {!props.betBuilder && <CashoutLabel bet={props} />}
                        </div>
                        {props.showFavoritesToggle && !props.betBuilder &&
                            <div className="pin-toggle ml-auto mr-4" onClick={toggleFavorite}>
                            {conf.iwh ?   <FavoriteWh className={`${classIf(favoritesContext.isMarketFavorite(sportRef, betId), 'selected')} favoriteWh`}></FavoriteWh>
                            : 
                            <PinIcon className={classIf(favoritesContext.isMarketFavorite(sportRef, betId), 'selected')}></PinIcon>}
                                
                            </div>
                        }
                    </div>
                    <div className={`collapse tabella-quote-extra d-grid bg-grigio-chiaro padding-verticale colonne-${getNumberOfCols(props.odds)}` + classIf(!collapsed, 'show')} id={"barra-extra-" + props.uniqueId }>
                        {!collapsed && oddsList}
                    </div>
                </div>
            </div>
        </div>
    );
}

function getNumberOfCols(odds) {
    if (HANDICAP_TYPES_TO_FORCE_ONE_COLUMN.includes(odds[0].betData.tipoHandicap)) {
        return 1;
    }
    const oddsLength = odds.length;
    return oddsLength >= 1 && oddsLength <= 3 ? oddsLength : 2;
}

export default MatchBet;